import { render, staticRenderFns } from "./comparisonOfPowerTable.vue?vue&type=template&id=3d63a4c7&scoped=true"
import script from "./comparisonOfPowerTable.vue?vue&type=script&lang=js"
export * from "./comparisonOfPowerTable.vue?vue&type=script&lang=js"
import style0 from "./comparisonOfPowerTable.vue?vue&type=style&index=0&id=3d63a4c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d63a4c7",
  null
  
)

export default component.exports